<template>
    <div class="select-wrapper">
        <div
            class="selected-box"
            :class="{'is-selected': value || collapsed, 'collapsed': collapsed}"
            @click.stop="selectBoxClickHandler"
        >
            <span class="title">{{title}}</span>
            {{selectedOptionName}}
            <i
                class="material-icons clear"
                v-show="value.length > 0"
                @click.stop="clear"
            >cancel</i>
        </div>
        <input
            type="text"
            class="hidden-input-for-validation"
            v-model="value"
            :required="isRequired"
        />
        <ul class="options" v-show="collapsed">
            <li
                @click="optionClickHandler('')"
                :class="{'selected': value == ''}"
                v-if="hasEmptyOption"
            ></li>
            <li
                v-for="(option, i) in options"
                :key="i"
                @click="optionClickHandler(option.value)"
                :class="{'selected': value == option.value}"
            >{{option.title}}</li>
        </ul>
    </div>
</template>

<script>
export default {
    mounted() {
        document.addEventListener('click', this.documentClickHandler)
    },
    props: {
        title: String,
        options: Array,
        value: String | Number,
        isRequired: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            collapsed: false,
        }
    },
    methods: {
        selectBoxClickHandler() {
            this.collapsed = !this.collapsed
        },
        optionClickHandler(value) {
            this.collapsed = false
            this.$emit('input', value)
        },
        clear() {
            this.$emit('clear')
            this.collapsed = false
        },
        documentClickHandler() {
            this.collapsed = false
        },
    },
    computed: {
        selectedOptionName() {
            var opt = this.options.filter(el => el.value == this.value)[0]
            if (opt) return opt.title
            return ''
        },
        hasEmptyOption() {
            this.options.forEach(elem => {
                if (elem.value == '') return true
            })
            return false
        },
    },
    destroyed() {
        document.removeEventListener('click', this.documentClickHandler)
    },
}
</script>

<style scoped lang="scss">
$border-color: $green-main;

.select-wrapper {
    position: relative;
    width: 197 * $rem;


    .selected-box {
        position: relative;
        display: inline-block;
        height: 40 * $rem;
        border-radius: 5 * $rem;
        background-color: white;
        border: 1 * $rem solid #b4b4b4;
        font-size: 15 * $rem;
        width: 100%;
        cursor: pointer;
        display: flex;
        align-items: center;
        padding-left: 15 * $rem;

        span.title {
            color: rgb(70, 70, 70);
            position: absolute;
            top: 10 * $rem;
            font-size: 15 * $rem;
            transition: all 0.2s ease-out;
            background-color: white;
            white-space: nowrap;
            cursor: text;
            cursor: pointer;
        }

        .material-icons {
            font-size: 18 * $rem;
            position: absolute;
            right: 15 * $rem;
            top: 10 * $rem;

            &.clear {
                cursor: pointer;
                color: #b4b4b4;
            }
        }

        &.is-selected {
            span {
                top: -6 * $rem;
                font-size: 12 * $rem;
                color: $border-color;
                padding-left: 2 * $rem;
                padding-right: 2 * $rem;
                left: 15 * $rem;
            }
        }

        &.collapsed {
            border: 1 * $rem solid $border-color;
        }
    }

    ul {
        padding: 5 * $rem 0;
        list-style: none;
        border-radius: 3 * $rem;
        position: absolute;
        width: 197 * $rem;
        background-color: #fff;
        z-index: 10;
        top: 47 * $rem;
        max-height: 300 * $rem;
        overflow-y: auto;
        box-shadow: 0 5 * $rem 5 * $rem -3 * $rem rgba(0, 0, 0, 0.2),
            0 * $rem 8 * $rem 10 * $rem 1 * $rem rgba(0, 0, 0, 0.14),
            0 * $rem 3 * $rem 14 * $rem 2 * $rem rgba(0, 0, 0, 0.12);
        animation: show .1s linear;

        li {
            min-height: 49 * $rem;
            padding: 15 * $rem;
            cursor: pointer;

            &:hover {
                background-color: rgba(214, 214, 214, 0.2);
            }

            &.selected {
                background: rgba(214, 214, 214, 0.5);
            }
        }
    }

    .hidden-input-for-validation {
        opacity: 0;
        width: 0;
        height: 0;
        margin-left: 50 * $rem;
        position: absolute;
    }

    @keyframes show {
        0% {
            opacity: 0.5;
            top: 30 * $rem;
        }
    }
}
</style>
